import {
  BlocksIcon,
  BookMarkedIcon,
  ChartPieIcon,
  UsersRoundIcon,
  FolderCodeIcon,
  GoalIcon,
  MegaphoneIcon,
  MessagesSquareIcon,
  RocketIcon,
  WalletIcon,
  ZapIcon,
} from 'lucide-react';

import IfIcon from '@/components/atoms/Icons/IfIcon';
import Brand from '@/components/atoms/Icons/Navigation/Brand';

const ICON_CLASS = 'text-muted-foreground';
const NAV_ICON_COLOR = 'var(--nav-foreground)';
const NAV_ICON_SIZE = 16;

export const navigationItems = (deskId: string, showBroadcasts?: boolean, showDebts?: boolean) => [
  // This icon has a size of 18px to match the hover state of the other navigation items
  // Brand paints `fill` from its `color` prop and ignores currentColor, so a text-* class has no effect
  { icon: <Brand className="opacity-100!" size={18} color="var(--nav-foreground)" />, link: '/' },
  {
    icon: <ZapIcon color={NAV_ICON_COLOR} size={NAV_ICON_SIZE} />,
    link: '/ai-agents',
    i18nKey: 'common.ai_agents',
  },
  {
    icon: <BookMarkedIcon color={NAV_ICON_COLOR} size={NAV_ICON_SIZE} />,
    link: '/knowledge-bases',
    i18nKey: 'ai_agents.navigation.knowledge',
  },
  {
    icon: <GoalIcon color={NAV_ICON_COLOR} size={NAV_ICON_SIZE} />,
    link: '/campaigns',
    i18nKey: 'common.campaigns',
  },
  {
    icon: <UsersRoundIcon color={NAV_ICON_COLOR} size={NAV_ICON_SIZE} />,
    link: '/contacts',
    i18nKey: 'main_navigation.contacts',
  },
  ...(showDebts
    ? [
        {
          icon: <WalletIcon color={NAV_ICON_COLOR} size={NAV_ICON_SIZE} />,
          link: '/debts',
          i18nKey: 'contacts.debts.title',
        },
      ]
    : []),
  // Show broadcasts as a separate option after campaigns if showBroadcasts is true
  ...(showBroadcasts
    ? [
        {
          icon: <MegaphoneIcon color={NAV_ICON_COLOR} size={NAV_ICON_SIZE} />,
          link: '/broadcasts',
          i18nKey: 'common.broadcasts',
        },
      ]
    : []),
  {
    icon: <ChartPieIcon color={NAV_ICON_COLOR} size={NAV_ICON_SIZE} />,
    link: '/analytics',
    i18nKey: 'main_navigation.analytics',
  },
  {
    icon: <MessagesSquareIcon color={NAV_ICON_COLOR} size={NAV_ICON_SIZE} />,
    link: '/chats',
    i18nKey: 'main_navigation.chat',
  },
  {
    icon: <RocketIcon color={NAV_ICON_COLOR} size={NAV_ICON_SIZE} />,
    i18nKey: 'main_navigation.deploy',
    submenuItems: [
      {
        icon: <BlocksIcon size={16} className={ICON_CLASS} />,
        i18nKey: 'main_navigation.connections',
        link: deskId ? `/environments/${deskId}/integrations` : '/integrations',
      },
      {
        icon: <IfIcon className={ICON_CLASS} />,
        i18nKey: 'main_navigation.rules',
        link: deskId ? `/environments/${deskId}/rules` : '/rules',
      },
      {
        icon: <FolderCodeIcon size={18} className={ICON_CLASS} />,
        i18nKey: 'developer_tools.title',
        link: '/devtools',
      },
    ],
  },
];

export type NavItem = ReturnType<typeof navigationItems>[number];
